import moment from 'moment';
import mtz from 'moment-timezone';
import { getCurrentLocale } from '../../common/utils/cookies';
import 'moment/min/locales';
import i18n from '../../internationalization/internationalization';

/**
 * @param date
 * @returns localized date with format (ex: 4:30AM EST 20 August, 2021)
 */
export const getFormattedDeadlineDate = (date: number): string => {
  const locale = getCurrentLocale();
  let formattedDate = '';
  // Date should not be 31/12/9999
  if (date < 253402257601913) {
    moment.locale(locale);
    formattedDate = mtz.tz(moment(date), mtz.tz.guess(true)).format('h:mmA z D MMMM, YYYY');
  }
  return formattedDate;
};

/**
 * @param date
 * @returns localized date with format (ex: 4:30:45AM EST 20 August, 2021)
 */
export const getTCPlusFormattedDeadlineDate = (date: string): string => {
  const locale = getCurrentLocale();
  let formattedDate = '';
  const format = 'h:mm:ssA z D MMMM, YYYY';
  // Date should not be 31/12/9999
  if (date) {
    moment.locale(locale);
    formattedDate = moment.tz(date, 'Asia/Kolkata').clone().tz(moment.tz.guess()).format(format);
  }
  return formattedDate;
};

/**
 * @param date
 * @returns localized date with format (ex: 4:30AM EST 10/20/2020)
 */
export const getFormattedScheduledTaskDate = (date: number): string => {
  const locale = getCurrentLocale();
  moment.locale(locale);
  return mtz.tz(date, mtz.tz.guess(true)).format('h:mmA z MM/DD/YYYY');
};

export const getValidateScheduledAssessmentDate = (date: string): number => {
  const validatedDate = parseInt(date.replace('/Date(', '').replace(')/', ''));
  if (isNaN(validatedDate)) {
    return 0;
  }
  return validatedDate;
};

const monthMap = ['Jan', 'Feb', 'March', 'April', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];

/**
 * @param withYear
 * @param startDateString
 * @param endDateString
 * @returns
 *    if endDate provided 'July 22, 2023 - Oct 31, 2024'
 *    else
 *      with Year  '02:40 AM, Oct 31'
 *      without Year ' 02:40 AM Oct 31, 2024'
 */
export const getFormatedBannerDates = (startDateString: string, withYear: boolean, endDateString?: string): string => {
  moment.locale(getCurrentLocale());
  const startDate = mtz.tz(startDateString, 'Asia/Kolkata').clone().tz(moment.tz.guess());
  const startMonth = i18n.t(monthMap[startDate.month()]);
  let startYear = startDate.format(', YYYY');

  if (endDateString) {
    const endDate = mtz.tz(endDateString, 'Asia/Kolkata').clone().tz(moment.tz.guess());
    let endMonth = i18n.t(monthMap[endDate.month()]);
    const endYear = endDate.format(', YYYY');

    if (startYear === endYear) startYear = '';
    if (startYear === '' && startMonth === endMonth) endMonth = '';

    return `${startMonth} ${startDate.format('DD')}${startYear} - ${endMonth} ${endDate.format('DD')}${endYear}`;
  }
  return `${startDate.format('hh:mm a,')} ${startMonth} ${startDate.format('DD')}${withYear ? startYear : ''}`;
};

export const areDatesEqual = (firstDate: string, secondDate: string): boolean => {
  const date1 = mtz.tz(firstDate, 'Asia/Kolkata').clone().tz(moment.tz.guess());
  const date2 = mtz.tz(secondDate, 'Asia/Kolkata').clone().tz(moment.tz.guess());

  return date1.valueOf() === date2.valueOf();
};
